import React, { memo } from 'react';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import Portal from '@Shared/Portal';

const ChatUi = memo(() => {
  return (
    <Portal>
      <MfeReactComponent component="default" module="CarvanaChatUiModule">
        {({ Component }) => <Component />}
      </MfeReactComponent>
    </Portal>
  );
});

export default ChatUi;
